import { Route, Routes as RouterRoutes, useParams } from "react-router-dom";
import routes from "./routes";
import AuthRoute from "../../../../components/AuthRoute";
import { useMutation, useQuery } from "@apollo/client";
import { FETCH_ARTIST as fetchArtist } from "../../../../graphql/query/Artist";
import { UPDATE_ARTIST as updateArtistMutation } from "../../../../graphql/mutation/Artist";
import { useEffect, useRef } from "react";
import { useFormik } from "formik";
import { getChangedFields, Portal } from "../../../../util";
import { NavBar } from "../../../../components/ui";

const Body = props => {
  return (
    <RouterRoutes>
      {routes
        ?.filter?.(item => item?.element)
        ?.map((item, index) => {
          return (
            <Route
              key={index}
              path={item?.href}
              element={
                <AuthRoute permissions={item.permissions}>
                  <item.element {...props} />
                </AuthRoute>
              }
            />
          );
        })}
    </RouterRoutes>
  );
};

const Wizard = props => {
  const { id } = useParams();
  const { data: { artist } = {} } = useQuery(
    fetchArtist({
      // Basic info fields (Infos component)
      contactId: true,
      represented: true,
      confidential: true,
      name: true,
      copyright: true,
      mailingList: true,
      droitdesuite: true,
      // Born fields (ArtistBorn component)
      bornDate: true,
      bornTown: true,
      bornCountryId: true,
      // Accounts fields (AccountsInfo component)
      sageCost: true,
      defaultFabRate: true,
      defaultSplitRate: true,
      sharedDiscount: true,
      // Consignment terms
      terms: true,
      // Contact association for ContactAddress and ContactAttributes
      contact: {
        id: true,
      },
    }),
    {
      variables: { id: +id },
    },
  );

  const [updateArtist, { loading }] = useMutation(
    updateArtistMutation({
      contact: {
        id: true,
      },
    }),
    {
      refetchQueries: [fetchArtist],
    },
  );

  const abortController = useRef();

  const formik = useFormik({
    initialValues: artist ? artist : [],
    enableReinitialize: true,
    onSubmit: values => {
      updateArtistValue(values);
    },
  });

  const updateArtistValue = values => {
    const changedFields = getChangedFields(values, artist);

    if (Object.keys(changedFields).length > 0) {
      const controller = new AbortController();
      abortController.current = controller;

      updateArtist({
        variables: {
          input: {
            id: +id,
            ...changedFields,
          },
        },
        context: {
          fetchOptions: {
            signal: controller.signal,
          },
        },
      });
    }
  };

  useEffect(() => {
    if (formik?.values && abortController?.current) {
      abortController.current.abort();
    }
  }, [formik?.values]);

  useEffect(() => {
    formik.resetForm({
      values: {
        ...artist,
      },
    });
  }, [artist]);

  const bodyProps = {
    ...props,
    artist,
    artistId: +id,
    formik,
    loading,
    updateArtist,
    updateArtistValue,
  };

  return (
    <div className="relative flex min-h-full">
      <Portal id="sidebar">
        <NavBar
          navigation={routes?.filter?.(item => item?.icon)}
          open={props?.open}
        />
      </Portal>
      <div className="m-8 mr-[80px] flex flex-1 overflow-x-auto">
        {artist && <Body {...bodyProps} />}
      </div>
    </div>
  );
};

export default Wizard;
